var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"text-3xl mb-8"},[_vm._v("Dashboard")]),_c('onboarding',{staticClass:"mb-12"}),_c('organizer-stats')],1)}
var staticRenderFns = []

export { render, staticRenderFns }